import React from "react";
import Sidebar from "./components/Sidebar/Sidebar";
import Topbar from "./components/Torbar";
import { alpha, Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { SIDEBAR_WIDTH } from "./sidebar";
import { useTranslation } from "react-i18next";
import { AccountContext } from "services/account";

const Main = ({
	children,
	title = "MiChat",
	...rest
}: {
	children?: React.ReactNode;
	title?: React.ReactNode;
	[x: string]: any;
}) => {
	const theme = useTheme();
	const { t } = useTranslation();
	const account = React.useContext(AccountContext);
	const isSm = useMediaQuery(theme.breakpoints.down("sm"));
	const [open, setOpen] = React.useState<boolean>(isSm ? false : JSON.parse(localStorage.getItem("sidebar")) || false);

	const [footerHeight, setFooterHeight] = React.useState(0);
	const footerRef = React.useRef();

	React.useEffect(() => {
		localStorage.setItem("sidebar", JSON.stringify(open));
	}, [open]);

	React.useEffect(() => {
		const observer = new ResizeObserver((entries) => {
			for (let entry of entries) {
				setFooterHeight(entry.borderBoxSize[0].blockSize);
			}
		});

		if (footerRef.current) {
			observer.observe(footerRef.current);
		}

		return () => {
			if (footerRef.current) {
				observer.unobserve(footerRef.current);
			}
		};
	}, []);

	return (
		<>
			<Box
				height={1}
				pb={footerHeight + "px"}
				overflow="hidden"
				sx={{ bgcolor: "alternate.main" }}>
				<Topbar
					open={open}
					setOpen={setOpen}
					title={title}
				/>
				<Sidebar
					open={open}
					setOpen={setOpen}
				/>
				<Box
					display="flex"
					flex="1 1 auto"
					overflow="hidden"
					height={1}
					pt={8}
					pl={{ sm: open ? SIDEBAR_WIDTH + "px" : `calc(${theme.spacing(8)} + 1px)` }}
					sx={{
						transition: theme.transitions.create("padding", {
							easing: theme.transitions.easing.sharp,
							duration: theme.transitions.duration.enteringScreen,
						}),
					}}>
					<Box
						display="flex"
						flex="1 1 auto"
						overflow="hidden">
						<Box
							flex="1 1 auto"
							height="100%"
							{...rest}
							sx={{ overflowY: "auto" }}>
							{children}
						</Box>
					</Box>
				</Box>
			</Box>
			{/* Footer */}
			{account.value.paidCredit + account.value.earnedCredit <= account.value.minimumCredit && (
				<Box
					ref={footerRef}
					position="fixed"
					width={1}
					bottom={0}
					py={1}
					px={2}
					sx={{
						zIndex: (theme) => theme.zIndex.drawer,
						bgcolor: theme.palette.error.main,
						color: "white",
						bordertop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
					}}>
					<Typography>
						{t("spendAllCredit1")}
						<Box
							component={"a"}
							href="mailto:info@mi-its.com"
							color={theme.palette.secondary.main}
							sx={{ fontWeight: "bold" }}>
							info@mi-its.com
						</Box>
						{t("spendAllCredit2")}
					</Typography>
				</Box>
			)}
		</>
	);
};
export default Main;
